{
  "callback": {
    "authenticating": "Signing In",
    "processing": {
      "auth": "Processing authentication...",
      "exchanging_code": "Exchanging authorization code...",
      "success_redirect": "Success! Redirecting to dashboard..."
    },
    "success": {
      "title": "Authentication Successful"
    },
    "error": {
      "title": "Authentication Failed",
      "message": "We encountered an issue while signing you in.",
      "try_again": "Try Again",
      "redirect_message": "You will be redirected to the home page in a few seconds."
    },
    "info_message": "Please wait while we securely sign you in."
  },
  "logout": {
    "signing_out": "Signing Out",
    "signing_out_message": "Clearing your session...",
    "success_message": "You have been successfully signed out.",
    "logout_completed": "Sign out completed.",
    "signed_out": "Signed Out",
    "redirect_message": "You will be redirected to the home page shortly.",
    "go_home": "Go to Home Page"
  }
}